<template>
  <div>
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2 mr-2">Assign Vehicle</h5>
    </div>
    <b-overlay :show="busy">
      <b-card-group deck>
        <b-card
          :header="'Available Vehicle (' + totalAvailable + ')'"
          header-tag="header"
        >
          <b-input-group v-if="totalAvailable">
            <b-input-group-prepend>
              <b-btn variant="primary">
                <b-form-checkbox
                  v-model="checkAllAvailable"
                  id="check-all-available"
                  :value="true"
                >{{ checkAllAvailableText }}</b-form-checkbox>
              </b-btn>
            </b-input-group-prepend>
            <b-form-input debounce="200" v-model="searchAvailable" placeholder="Search"></b-form-input>
          </b-input-group>
          <b-list-group v-if="totalAvailable" class="list__container mb-2">
            <b-list-group-item v-for="vehicle in availableList" :key="vehicle.id" class="d-flex justify-content-between align-items-center vehicle--item">
              <b-form-checkbox
                v-model="vehicle.check"
                @input="onTickCheckboxAvailable"
                :value="vehicle.id"
                :id="`availabe_${vehicle.id}`"
              >{{ vehicle.reg_no }}</b-form-checkbox>
              <b-button :title="`Assign ${vehicle.reg_no}`" size="sm" @click="assignData(vehicle)" pill variant="outline-primary">
                <span class="button__move-right fa fa-arrow-right"></span>
              </b-button>
            </b-list-group-item>
          </b-list-group>
          <b-button
            v-if="totalAvailable"
            @click="multipleAssignData"
            :disabled="selectedAvailable.length === 0"
            class="float-right"
            variant="outline-primary">Assign ({{ selectedAvailable.length }})</b-button>
          <b-alert v-if="!totalAvailable" show variant="warning">No available vehicles</b-alert>
        </b-card>
        <b-card
          :header="'Assigned Vehicle (' + totalAssigned + ')'"
          header-tag="header"
        >
          <b-input-group v-if="totalAssigned">
            <b-form-input debounce="200" v-model="searchAssigned" placeholder="Search"></b-form-input>
            <b-input-group-append>
              <b-btn class="d-flex" variant="primary">
                <label class="ml-auto mb-0" for="check-all-assigned">{{ checkAllAssignedText }}</label>
                <b-form-checkbox
                  class="ml-2 mr-n2"
                  id="check-all-assigned"
                  v-model="checkAllAssigned"
                  :value="true"
                ></b-form-checkbox>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-list-group v-if="totalAssigned" class="list__container mb-2">
            <b-list-group-item v-for="vehicle in assignedList" :key="vehicle.id" class="d-flex justify-content-between align-items-center vehicle--item">
              <b-button @click="unassignData(vehicle)" :title="`Unassign ${vehicle.reg_no}`" pill variant="outline-primary" size="sm">
                <span class="button__move-left fa fa-arrow-left"></span>
              </b-button>
              <label :for="`assigned_${vehicle.id}`" class="ml-auto mb-0">{{ vehicle.reg_no }}</label>
              <b-form-checkbox
                class="ml-2 mr-n2"
                v-model="vehicle.check"
                @input="onTickCheckboxAssigned"
                :value="vehicle.id"
                :id="`assigned_${vehicle.id}`"
              ></b-form-checkbox>
            </b-list-group-item>
          </b-list-group>
          <b-button
            @click="multipleUnassign"
            :disabled="selectedAssigned.length === 0"
            v-if="totalAssigned"
            variant="outline-primary">Unassign ({{ selectedAssigned.length }})</b-button>
          <b-alert v-if="!totalAssigned" show variant="warning">No available assigned vehicles</b-alert>
        </b-card>
      </b-card-group>
    </b-overlay>
  </div>
</template>

<script>
import { isEmpty, concat, get } from 'lodash';
// import { log } from 'util';

export default {
  name: 'assign_vehicle',
  data() {
    return {
      searchAvailable: '',
      searchAssigned: '',
      selectedVehicle: [],
      selectTotal: '',
      payload: {
        vehicle_ids: [],
      },
      availableList: [],
      assignedList: [],
      assignedData: [],
      busy: false,
      checkAllAvailableText: 'Check All',
      checkAllAssignedText: 'Check All',
      checkAllAvailable: false,
      checkAllAssigned: false,
      selectedAvailable: [],
      selectedAssigned: [],
    };
  },
  created() {
    const { vehicleGroupId } = this.$route.params;
    this.$store.commit('vehicle_group/SET_DETAIL_ID', vehicleGroupId);
    const breadcrumb = [
      { to: '', name: 'Home' },
      { to: 'vehicle_group', name: 'Vehicle Group' },
      { to: vehicleGroupId, name: 'Detail' },
    ];
    this.$store.commit('SET_BREADCRUMB_ITEMS', breadcrumb);
    this.$store.dispatch('vehicle_group/LOAD_DETAIL_DATA');
    this.loadData();
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['vehicle_group/get_detail_data'];
    },
    count_vehicle() {
      return this.$store.getters['vehicles/count_all'];
    },
    allVehicles() {
      return this.$store.getters['vehicles/vehicles'];
    },
    assignedVehicles() {
      const currentAssignedVehicle = get(this.detailedInfo, 'members', []);
      return currentAssignedVehicle;
    },
    availableVehicles() {
      const assignedIds = this.assignedVehicles.map(dt => dt.id);
      const listVehicle = this.allVehicles.filter(dt => !assignedIds.includes(dt.id));
      return listVehicle;
    },
    totalAvailable() {
      return this.availableVehicles.length;
    },
    totalAssigned() {
      return this.assignedVehicles.length;
    },
  },
  watch: {
    availableVehicles(data) {
      this.availableList = data
        .map(this.formatVehicleData)
        .sort(this.sortCompareVehicleData);
    },
    assignedVehicles(data) {
      this.assignedList = data
        .map(this.formatVehicleData)
        .sort(this.sortCompareVehicleData);
      this.assignedData = data
        .map(this.formatVehicleData)
        .sort(this.sortCompareVehicleData);
    },
    searchAvailable(value) {
      this.availableList = this.availableVehicles
        .map(this.formatVehicleData)
        .sort(this.sortCompareVehicleData);
      if (!isEmpty(value)) {
        const regExp = new RegExp(value, 'i');
        this.availableList = this.availableVehicles
          .filter(dt => dt.reg_no.match(regExp))
          .map(this.formatVehicleData);
      }
    },
    searchAssigned(value) {
      this.assignedList = this.assignedVehicles
        .map(this.formatVehicleData)
        .sort(this.sortCompareVehicleData);
      if (!isEmpty(value)) {
        const regExp = new RegExp(value, 'i');
        this.assignedList = this.assignedVehicles
          .filter(dt => dt.reg_no.match(regExp))
          .map(this.formatVehicleData);
      }
    },
    checkAllAvailable(isCheckAll) {
      this.checkAllAvailableText = isCheckAll ? 'Uncheck All' : 'Check All';
      this.availableList.map((item) => {
        item.check = isCheckAll ? item.id : false;
        return item;
      });
    },
    checkAllAssigned(isCheckAll) {
      this.checkAllAssignedText = isCheckAll ? 'Uncheck All' : 'Check All';
      this.assignedList.map((item) => {
        item.check = isCheckAll ? item.id : false;
        return item;
      });
    },
  },
  methods: {
    formatVehicleData(dt) {
      return {
        id: dt.id,
        reg_no: dt.reg_no,
      };
    },
    sortCompareVehicleData(a, b) {
      if (a.reg_no < b.reg_no) { return -1; }
      if (a.reg_no > b.reg_no) { return 1; }
      return 0;
    },
    loadData() {
      this.busy = true;
      return this.$store.dispatch('vehicles/LOAD_INFO').then(() => {
        this.$store.commit('vehicles/SET_QUERY_COUNT', this.count_vehicle);
        this.$store.dispatch('vehicle_group/LOAD_DETAIL_DATA').then(() => {
          this.$store.dispatch('vehicles/LOAD_DATA').then(() => {
            this.busy = false;
          });
        });
      });
    },
    assignData(data) {
      const indexAvailable = this.availableList.findIndex(dt => dt.id === data.id);
      const targetData = this.availableList.splice(indexAvailable, 1);
      this.assignedData.push(targetData[0]);
      this.assignedList.push(targetData[0]);

      const assignedIds = this.assignedData.map(dt => dt.id);
      this.saveData(assignedIds);
    },
    unassignData(data) {
      const indexAssignedList = this.assignedList.findIndex(dt => dt.id === data.id);
      this.assignedList.splice(indexAssignedList, 1);

      const indexAssigned = this.assignedData.findIndex(dt => dt.id === data.id);
      const targetData = this.assignedData.splice(indexAssigned, 1);
      this.availableList.push(targetData[0]);

      const assignedIds = this.assignedData.map(dt => dt.id);
      this.saveData(assignedIds);
    },
    saveData(data) {
      this.busy = true;
      const { vehicleGroupId } = this.$route.params;
      this.$store.dispatch('vehicle_group/MOVE_ASSIGN_VEHICLE_DATA', {
        group_id: vehicleGroupId,
        vehicle_ids: data,
      }).then(() => {
        this.busy = false;
        this.loadData().then(() => {
          this.reset();
          this.$store.dispatch('vehicle_group/LOAD_DETAIL_DATA');
        });
      });
    },
    multipleAssignData() {
      const vehicleIds = concat(this.assignedData.map(dt => dt.id), this.selectedAvailable);
      this.saveData(vehicleIds);
    },
    multipleUnassign() {
      const vehicleIds = this.assignedData
        .filter(dt => !this.selectedAssigned.includes(dt.id))
        .map(dt => dt.id);
      this.saveData(vehicleIds);
    },
    onTickCheckboxAvailable() {
      this.selectedAvailable = this.availableList
        .filter(dt => dt.check)
        .map(dt => dt.id);
    },
    onTickCheckboxAssigned() {
      this.selectedAssigned = this.assignedList
        .filter(dt => dt.check)
        .map(dt => dt.id);
    },
    reset() {
      this.searchAvailable = '';
      this.searchAssigned = '';
      this.selectedAvailable = [];
      this.selectedAssigned = [];
      this.checkAllAvailable = false;
      this.checkAllAssigned = false;
    },

    sortCompareVehicleGroupData(a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  .button__move-left, .button__move-right {
    cursor: pointer;
  }

  .list__container {
    min-height: 300px;
    max-height: 300px;
    overflow: auto;
  }

  .vehicle--item {
    padding: 0.5rem 1.25rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/pages/vehicle_group/detail/AssignVehicle.vue